module.exports = __webpack_public_path__ + "static/media/partitionPatterns.b042020a.png";